import { Unstable } from "@flash-tecnologia/hros-web-ui-v2";
import styled from "styled-components";

export const StyledDrawer = styled(Unstable.Drawer)`
  &.MuiModal-root {
    div {
      &.MuiPaper-root {
        max-width: 560px;
        width: 45%;
        padding: ${({ theme }) => theme.spacings.xs2} 0
          ${({ theme }) => theme.spacings.xs3};
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacings.xs};

        & > div:first-child > div {
          gap: ${({ theme }) => theme.spacings.xs5};
        }

        & h6 {
          font-size: 20px;
        }

        & p {
          font-size: 14px;
        }
      }

      &.MuiPaper-root > div:first-child {
        padding: 0 ${({ theme }) => theme.spacings.xs};
      }
  }
`;

export const StyledDrawerContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.xs};
  padding: 0 ${({ theme }) => theme.spacings.xs};
`;
